import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';
import { AppLayout } from './components/AppLayout';
import { DashboardPage } from './pages/Dashboard';
import { PedidosPage } from './pages/Pedidos';
import { ClientesPage } from './pages/Clientes';
import { FacturasPage } from './pages/Facturas';
import { CobranzasPage } from './pages/Cobranzas';
import { ComprasPage } from './pages/Compras';
import { ProveedoresPage } from './pages/Proveedores';
import { InventarioPage } from './pages/Inventario';
import { BancaPage } from './pages/Banca';
import { ContabilidadPage } from './pages/Contabilidad';
import { ReportesPage } from './pages/Reportes';
import { RetencionesPage } from './pages/Retenciones';
import { UsuariosPage } from './pages/Usuarios';
import { ImprentaPage } from './pages/Imprenta';
import { LoginPage } from './pages/Login';

function BootSplash() {
  return (
    <div className="boot-splash" role="status" aria-live="polite">
      <div className="boot-splash__brand">
        <img src="/brand/isotipo-green.png" alt="GRAVENCA" />
        <div>
          <strong>GRAVENCA</strong>
          <span>Preparando tu operación…</span>
        </div>
      </div>
      <span className="loader" aria-hidden="true" />
    </div>
  );
}

function ProtectedRoute() {
  const { user, status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <BootSplash />;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="pedidos" element={<PedidosPage />} />
          <Route path="clientes" element={<ClientesPage />} />
          <Route path="facturas" element={<FacturasPage />} />
          <Route path="cobranzas" element={<CobranzasPage />} />
          <Route path="compras" element={<ComprasPage />} />
          <Route path="proveedores" element={<ProveedoresPage />} />
          <Route path="inventario" element={<InventarioPage />} />
          <Route path="banca" element={<BancaPage />} />
          <Route path="contabilidad" element={<ContabilidadPage />} />
          <Route path="reportes" element={<ReportesPage />} />
          <Route path="retenciones" element={<RetencionesPage />} />
          <Route path="usuarios" element={<UsuariosPage />} />
          <Route path="imprenta" element={<ImprentaPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
